import { render, staticRenderFns } from "./VulnFeedTable.vue?vue&type=template&id=75064a4b&scoped=true"
import script from "./VulnFeedTable.vue?vue&type=script&lang=js"
export * from "./VulnFeedTable.vue?vue&type=script&lang=js"
import style0 from "./VulnFeedTable.vue?vue&type=style&index=0&id=75064a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75064a4b",
  null
  
)

export default component.exports